import React from 'react';
import './BookDemoTeamSection.css';

const BookDemoTeamSection = () => {
  return (
    <section className="book-demo-team-section">
      <div className="book-demo-team-container">
        <div className="book-demo-team-left">
          <h2>
            Created by a team of AI researchers and healthcare professionals with <span className="highlight">10+ years</span> of experience.
          </h2>
          <button className="book-demo-team-btn">Join Team</button>
        </div>
        <div className="book-demo-team-right">
          <img src="/images/bookDemo.png" alt="Doctor video call" />
        </div>
      </div>
      <hr className="book-demo-team-divider" />
    </section>
  );
};

export default BookDemoTeamSection; 